import React from 'react'
import { graphql, Link } from 'gatsby'
import get from 'lodash/get'
import Layout from '../components/layout'
import SectionRenderer from '../components/SectionRenderer'
import PageHeader from '../../giesswein-headless-components/src/components/PageHeader/PageHeader'
import Breadcrumb from '../../giesswein-headless-components/src/components/Breadcrumb/Breadcrumb'
import MetaBar from '../../giesswein-headless-components/src/components/MetaBar/MetaBar'
import './blog-post.scss'
import moment from 'moment'

class BlogPostTemplate extends React.Component {
  render() {
    const post = get(this.props, 'data.contentfulBlogPost')
    const updatedAt = [post.updatedAt]
      .concat(
        (get(post, 'body.json.content') || []).map(section =>
          get(section, 'data.target.sys.updatedAt')
        )
      )
      .filter(Boolean)
      .sort()
      .reverse()[0]
    const blogs = get(this.props, 'data.allShopifyBlog.edges') || []

    const data = {
      title: post.title,
      handle: post.slug,
      updatedAt,
      published_at: post.publishDate || post.createdAt,
      blog: ((post.blog && post.blog.slug) || 'news').toLowerCase(),
      tags: post.tags || [],
      title_tag: post.title_tag,
      summary_html: post.description && post.description.description,
      description_tag: post.description_tag,
      image: get(post, 'previewImage.file.url'),
    }

    console.log('post:', post)

    const jsonLD = {
      '@context': 'http://schema.org',
      '@type': 'BlogPosting',
      headline: post.title,
      description: post.description_tag,
      dateCreated: post.createdAt,
      image: get(post, 'previewImage.file.url'),
    }

    return (
      <React.Fragment>
        <Layout location={this.props.location}>
          <PageHeader
            title={post.title}
            category={post.blog.slug}
            date={post.publishDate || post.createdAt}
            image={get(post, 'image.file.url')}
            categories={blogs.map(blog => blog.node)}
          />

          <Breadcrumb
            category={post.blog.slug}
            baseLink={<a href={`/blogs/${post.blog.slug}`}>Blog</a>}
          />

          <span className="eg_blogpost__date">
            {moment(post.publishDate || post.createdAt).format('DD.MM.yyyy')}
          </span>
          <h1 className="eg_blogpost__title">{post.title}</h1>

          <div className="wrapper">
            <SectionRenderer json={post.body.json} />
            <MetaBar />
          </div>
        </Layout>
        <script id="data" type="application/json">
          {JSON.stringify(data)}
        </script>

        <script type="application/ld+json">{JSON.stringify(jsonLD)}</script>
      </React.Fragment>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    contentfulBlogPost(slug: { eq: $slug }) {
      title
      slug
      description {
        description
      }
      image {
        file {
          url
        }
      }
      previewImage {
        file {
          url
        }
      }
      blog {
        slug
      }
      createdAt
      updatedAt
      publishDate
      body {
        json
      }
      tags
      title_tag
      description_tag
    }
  }
`
